(function () {
  let imagesSlider;

  const removeActive = (elements) => {
    elements.forEach((el) => el.classList.remove("active"));
  };
  const hoverToggle = (section) => {
    const titles = section.querySelectorAll(".image-tabs-titles-item");
    const images = section.querySelectorAll(".image-tabs-image-outer");

    if (!titles.length || !images.length) return;

    const toggleActive = (title) => {
      removeActive(titles);
      removeActive(images);

      title.classList.add("active");

      const index = +title.dataset.imageTabsIndex;

      if (isNaN(index) || index < 0 || index >= images.length) return;

      images.forEach((image) => {
        const imageIndex = +image.dataset.imageTabsIndex;

        if (isNaN(imageIndex) || imageIndex < 0 || imageIndex >= images.length)
          return;

        if (imageIndex === index) image.classList.add("active");
      });
    };

    for (const title of titles) {
      const handleMouseOver = () => toggleActive(title);
      let isInit = false;

      if (window.innerWidth >= 750) {
        title.addEventListener("mouseover", handleMouseOver);
        isInit = true;
      } else {
        title.removeEventListener("mouseover", handleMouseOver);
        isInit = false;
      }

      window.addEventListener("resize", () => {
        if (window.innerWidth >= 750 && !isInit) {
          title.addEventListener("mouseover", handleMouseOver);
          isInit = true;
        } else if (window.innerWidth < 750 && isInit) {
          title.removeEventListener("mouseover", handleMouseOver);
          isInit = false;
        }
      });
    }
  };

  const initSlider = (section) => {
    const imagesSliderEl = section.querySelector(".js-images-slider");
    if (!imagesSliderEl) return;

    const imagesSliderElWrapper =
      imagesSliderEl.querySelector(".image-tabs-images");
    const imagesSliderElSlides = imagesSliderEl.querySelectorAll(
      ".image-tabs-image-outer"
    );

    imagesSliderEl.classList.add("swiper");
    imagesSliderElWrapper.classList.add("swiper-wrapper");

    imagesSliderElSlides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const hasPagination =
      imagesSliderEl.getAttribute("data-pagination") === "true";
    const paginationEl = section.querySelector(".slider-pagination");
    const sliderLoop = imagesSliderEl.getAttribute("data-loop") === "true";
    const hasSliderAutoplay =
      imagesSliderEl.getAttribute("data-autoplay") === "true";
    const autoplayDelay = Number(imagesSliderEl.dataset.autoplayDelay || 8000);

    imagesSlider = new Swiper(imagesSliderEl, {
      loop: sliderLoop,
      slidesPerView: 1,
      spaceBetween: 12,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: hasSliderAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: hasPagination
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
      on: {
        autoplayTimeLeft(s, time, progress) {
          if (hasPagination && paginationEl) {
            paginationEl.style.setProperty("--slider-progress", 1 - progress);
          }
        },
      },
    });
  };

  const destroySlider = () => {
    if (imagesSlider) {
      if (imagesSlider.wrapperEl) {
        imagesSlider.wrapperEl.removeAttribute("style");
      }
      imagesSlider.slides?.forEach((slide) => {
        slide.removeAttribute("style");
      });
      imagesSlider.destroy(true, false);
      imagesSlider = null;
    }
  };

  const initTabsSlider = (section) => {
    if (!section || !section?.classList.contains("image-tabs-section")) return;

    const resizeObserver = new ResizeObserver((entries) => {
      entries?.forEach((entry) => {
        if (window.innerWidth < 750 && !imagesSlider) {
          initSlider(section);
        } else if (window.innerWidth >= 750 && imagesSlider) {
          destroySlider(section);
        }
      });
    });

    resizeObserver.observe(section);
  };

  hoverToggle(document.currentScript.parentElement);
  initTabsSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    hoverToggle(event.target);
    initTabsSlider(event.target);
  });
})();
